import React, { useEffect } from 'react'
import { TemplateInputParameters } from '../../../../../models/AiFeature'
import { TemplateBox } from '../../../../../components/TemplateBox/TemplateBox'
import { GeneratingForm } from './GeneratingForm'
import { Container, Row } from 'react-bootstrap'
import { AiFeaturePreset } from '../../../../../models/AiFeaturePreset'
import { useGenerateTemplate } from './hooks'

interface PresetTemplateConfigFormProps {
  preset: AiFeaturePreset
  defaultInputParameters: TemplateInputParameters
  parentInputParameters: TemplateInputParameters
  inputParameters: TemplateInputParameters
  editedInputParameters: TemplateInputParameters
  showCustomizationSetting: boolean
  customized: boolean
  shouldReset: boolean
  shouldShowGenerate: boolean
  showGenerate: () => void
  onChangeTemplate: (newTemplate: string) => void
  onChangeExample: (field: string, newExample: string) => void
  onChangeCustomized?: () => void
  onGenerate: (isGenerating: boolean) => void
  disabled: boolean
}

export const PresetTemplateConfigForm: React.FC<PresetTemplateConfigFormProps> = ({
  preset,
  defaultInputParameters,
  parentInputParameters,
  inputParameters,
  editedInputParameters,
  showCustomizationSetting,
  customized,
  shouldReset,
  shouldShowGenerate,
  showGenerate,
  onChangeTemplate,
  onChangeExample,
  onChangeCustomized,
  onGenerate,
  disabled,
}) => {
  const { generateTemplate, generatingEnabled, generateIsLoading, generatedTemplate, errorMessage, clearGeneratedTemplate } = useGenerateTemplate(
    preset,
    editedInputParameters,
  )

  useEffect(() => {
    onGenerate(generateIsLoading)
  }, [generateIsLoading, onGenerate])

  useEffect(() => {
    if (shouldReset) {
      clearGeneratedTemplate()
    }
  }, [clearGeneratedTemplate, shouldReset])

  return (
    <>
      <Container>
        <Row>
          <div className='w-100 p-0'>
            <>
              {shouldShowGenerate && (
                <GeneratingForm
                  inputParameters={inputParameters}
                  onChangeExample={onChangeExample}
                  generateTemplate={generateTemplate}
                  generateIsLoading={generateIsLoading}
                  generatingEnabled={generatingEnabled}
                  errorMessage={errorMessage}
                  shouldReset={shouldReset}
                />
              )}
              {generateIsLoading ? (
                <div
                  className='skeleton w-100 text-center mb-3'
                  style={{
                    height: '9.25rem',
                    verticalAlign: 'middle',
                    lineHeight: '9.25rem',
                  }}
                >
                  Generating template… may take up to 1 minute. Please wait.
                </div>
              ) : (
                <TemplateBox
                  shouldShowGenerate={shouldShowGenerate}
                  onGenerate={showGenerate}
                  template={inputParameters.template}
                  defaultTemplate={defaultInputParameters.template}
                  parentTemplate={parentInputParameters.template}
                  generatedTemplate={generatedTemplate}
                  onChangeTemplate={onChangeTemplate}
                  customized={customized}
                  onChangeCustomized={onChangeCustomized}
                  showCustomizationSetting={showCustomizationSetting}
                  shouldReset={shouldReset}
                  disabled={disabled}
                  typeId={preset.id}
                />
              )}
            </>
          </div>
        </Row>
      </Container>
    </>
  )
}
